import changeResistanceImage from "@/assets/media/article-ai-change-resistance.jpg";
import transformationGuideImage from "@/assets/media/article-ai-transformation-guide.jpg";
import smallBusinessImage from "@/assets/media/article-ai-for-smb.jpg";
import enterpriseImage from "@/assets/media/article-ai-for-enterprise.jpg";
import fiveLessonsImage from "@/assets/media/article-wmt-ai-five-lessons.png";
import changeResistanceMarkdown from "@/content/business/change-resistance.md?raw";
import transformationGuideMarkdown from "@/content/business/transformation-guide.md?raw";
import smallBusinessMarkdown from "@/content/business/ai-for-small-business.md?raw";
import enterpriseMarkdown from "@/content/business/ai-for-enterprise.md?raw";
import fiveLessonsMarkdown from "@/content/business/five-lessons-from-wmt-ai.md?raw";

export interface BusinessArticle {
  slug: string;
  title: string;
  description: string;
  seoTitle?: string;
  seoDescription?: string;
  image: string;
  imageAlt: string;
  markdown: string;
}

import servicesImage from "@/assets/media/article-wmt-services.png";
import founderImage from "@/assets/media/article-wmt-founder.png";
import servicesMarkdown from "@/content/business/uslugi-wmt-ai.md?raw";
import founderMarkdown from "@/content/business/igor-nikitin-osnovatel-wmt-ai.md?raw";

export const businessArticles: BusinessArticle[] = [
  {
    slug: "uslugi-wmt-ai",
    title: "Услуги компании WMT AI: от обучения искусственному интеллекту до комплексной автоматизации бизнеса",
    description: "Консалтинг, обучение команды, разработка ИИ-агентов и готовые продукты для бизнеса.",
    seoTitle: "Обучение ИИ, автоматизация бизнеса, AI-трансформация | Услуги WMT AI",
    seoDescription: "Услуги WMT AI для бизнеса | ИИ-трансформация и консалтинг, корпоративное обучение нейросетям, разработка ИИ-агентов, автоматизация бизнес-процессов, HR-решения и образовательные проекты",
    image: servicesImage,
    imageAlt: "Бумажная композиция: команда и ИИ-ассистент работают над задачами бизнеса",
    markdown: servicesMarkdown,
  },
  {
    slug: "igor-nikitin-osnovatel-wmt-ai",
    title: "Игорь Никитин - основатель WMT AI и эксперт по внедрению искусственного интеллекта в бизнес",
    description: "Профессиональный путь основателя WMT AI и его подход к системной AI-трансформации компаний.",
    seoTitle: "Игорь Никитин | Биография, проекты, внедрение ии в бизнес | WMT AI",
    seoDescription: "Игорь Никитин | Основатель WMT AI, эксперт по AI-трансформации бизнеса и внедрению ИИ | Биография, проекты, услуги и решения WMT AI для бизнеса",
    image: founderImage,
    imageAlt: "Бумажная композиция о руководителе, команде и внедрении искусственного интеллекта",
    markdown: founderMarkdown,
  },
  {
    slug: "pyat-vyvodov-iz-opyta-wmt-ai",
    title: "Пять выводов из опыта WMT AI: как перейти от интереса к нейросетям к рабочим сценариям и измеримому результату",
    description: "Практические выводы о том, как превратить интерес к ИИ в устойчивую работу команды и измеримый результат для бизнеса.",
    seoTitle: "Как внедрить ИИ в работу команды: пять выводов WMT AI",
    seoDescription: "Как превратить интерес к нейросетям в рабочие сценарии и измеримый результат? | 5 практических выводов WMT AI: задачи, проверка результатов, правила, сценарии и обучение команды",
    image: fiveLessonsImage,
    imageAlt: "Команда разбирает рабочий сценарий применения ИИ",
    markdown: fiveLessonsMarkdown,
  },
  {
    slug: "s-chego-nachat-ii-transformatsiyu",
    title: "С чего начать AI-трансформацию в компании",
    description: "Пошаговый гайд: от аудита процессов до выбора пилотного проекта и масштабирования.",
    seoTitle: "ИИ-трансформация бизнеса: пошаговый план внедрения ИИ | WMT AI",
    seoDescription: "Как внедрить ИИ в бизнес и получить измеримый результат? | Пошаговый гайд: аудит процессов, выбор пилотного проекта, ИИ-архитектура, обучение команды и масштабирование | Опыт WMT AI",
    image: transformationGuideImage,
    imageAlt: "Визуализация связи между цифровой платформой и процессами компании",
    markdown: transformationGuideMarkdown,
  },
  {
    slug: "soprotivlenie-vnedreniyu-ii",
    title: "Как преодолеть сопротивление сотрудников внедрению ИИ",
    description: "Практические советы по управлению изменениями и обучению команды.",
    seoTitle: "Корпоративное обучение работе с ИИ и нейросетями для бизнеса | WMT",
    seoDescription: "Как преодолеть сопротивление команды при внедрении ИИ? | Читайте нашу статью по обучению сотрудников работе с искусственным интеллектом | Курсы ИИ-трансформации от экспертов WMT AI",
    image: changeResistanceImage,
    imageAlt: "Команда проходит обучение работе с искусственным интеллектом",
    markdown: changeResistanceMarkdown,
  },
  {
    slug: "ii-transformatsiya-dlya-malogo-i-srednego-biznesa",
    title: "AI-трансформация для малого и среднего бизнеса",
    description: "Решения без огромных бюджетов.",
    seoTitle: "AI-трансформация малого и среднего бизнеса: решения без больших бюджетов | WMT AI",
    seoDescription: "Как внедрить ИИ в малом и среднем бизнесе без больших затрат? | SaaS, no-code и готовые AI-решения, пилотирование и пошаговый план внедрения | Практические рекомендации от WMT AI",
    image: smallBusinessImage,
    imageAlt: "Сотрудник и картонный робот работают над задачей",
    markdown: smallBusinessMarkdown,
  },
  {
    slug: "ii-transformatsiya-dlya-krupnogo-biznesa",
    title: "AI-трансформация для крупного бизнеса",
    description: "Как кастомные ИИ-решения окупают многомиллионные инвестиции.",
    seoTitle: "AI-трансформация для крупного бизнеса: кастомные ИИ-решения и их окупаемость | WMT",
    seoDescription: "Как крупному бизнесу окупить инвестиции в ИИ? | Кастомные AI-решения для ценообразования, логистики, клиентского сервиса и предиктивного ремонта | Кейсы, ROI и подход WMT AI",
    image: enterpriseImage,
    imageAlt: "Специалист с цветными карандашами в творческом пространстве",
    markdown: enterpriseMarkdown,
  },
];

export const getBusinessArticle = (slug: string) =>
  businessArticles.find((article) => article.slug === slug);
